<!-- src/FullChapterListPage.vue -->

<template>
  <main>
    <div class="container mx-auto py-3 chapter-list-page" data-aos="fade-right">
      <div class="dark-gray-box-1 p-3">
        <h1 class="textmain MainTitleFont mb-3">Chapters</h1>
        <ChapterList size="large" />
      </div>
    </div>
  </main>
</template>

<style scoped>
.chapter-list-page {
  max-width: 900px;
}
</style>

<script>
  import ChapterList from '@/ChapterList.vue';
  import 'animate.css';

  export default {
    name: 'FullChapterListPage',
    components: {
      ChapterList,
    },
    mounted(){
      document.title = "Sins of Dissentia - Chapters";
    },
  }

</script>
